import "./style.less";

export default function DevelopmentBar(ENV, DummyApi, ActivityFactory, moment) {
    return {
        restrict: "E",
        scope: {},
        template: require("./template.html"),
        controller: ($scope, siteService, Users, $location, moment) => {
            // Abort if disabled
            if (!ENV.enableDevBar) {
                return false;
            }

            Users.getAuthenticatedUser().then(
                (res) => {
                    $scope.user = res;
                },
                (err) => {
                    console.warn(err);
                    $scope.user = null;
                }
            );

            $scope.env = ENV;

            $scope.enabledDummyApi = DummyApi.isEnabled();

            const dummyPeriods = DummyApi.getSearchPeriods();

            $scope.dummyDate = moment(dummyPeriods.SearchDate).format(
                "DD-MM-YYYY"
            );

            $scope.dummyLocation = dummyPeriods.ParentLanes[0].HallName;

            $scope.dummyActivity = ActivityFactory.getById(
                dummyPeriods.ParentLanes[0].Lanes[0].AvailabeCategories[0],
                DummyApi.getActivities()
            ).Name;

            $scope.dummyActivity = ActivityFactory.getById(
                dummyPeriods.ParentLanes[0].Lanes[0].AvailabeCategories[0],
                DummyApi.getActivities()
            ).Name;

            // Enabled ::::
            $scope.env = ENV;

            // siteService.headerHeight = "132"; // is set in coreController.js

            siteService.addBodyClass("has-devbar");

            $scope.flipUseDummyData = () => {
                $scope.enabledDummyApi = DummyApi.toggleEnableDummyApi();
            };

            const replacer = "__DATE__";

            const searchScenearios = [
                {
                    title: "Badminton - Hafnia",
                    weekday: null,
                    path: `/search/periods/badminton/hafnia-hallen?date=${replacer}&start=0&end=-1&hours=1`,
                },
                {
                    title: "Overlapping periods",
                    weekday: null,
                    path: `/search/periods/badminton/hafnia-hallen?date=${replacer}&start=0&end=-1&hours=1`,
                },

                {
                    title: "Cross Periods Lanes",
                    weekday: 6, // saturday
                    path: `/search/periods/badminton/sundby%C3%B8ster%20hal%201?date=${replacer}&start=0&end=-1&hours=1`,
                },
                {
                    title: "Periods with entries (bane 2)",
                    weekday: null,
                    path: `/search/periods/badminton/hafnia-hallen?date=${replacer}&start=0&end=-1&hours=1`,
                },
                {
                    title: "After midnight",
                    weekday: 2, // tuesday

                    path: `search/periods/badminton/bellahøjhallerne?date=${replacer}&start=0&end=-1&hours=1`,
                },
                {
                    title: "Fixed",
                    weekday: 2, // tuesday
                    path: `search/periods/fixed/badminton/grøndal%20multicenter?date=${replacer}&start=0&end=-1&hours=1&weeks=4`,
                },
            ];

            $scope.scenarios = searchScenearios;

            $scope.search = (scene) => {
                if (scene.weekday) {
                    const nextWeekdayDate = getWeekdayDate(scene.weekday);
                    scene.path = replaceSearchDate(scene.path, nextWeekdayDate);
                } else {
                    const tomorrow = moment()
                        .add(1, "days")
                        .format("DD-MM-YYYY");

                    scene.path = replaceSearchDate(scene.path, tomorrow);
                }

                $location.url(scene.path);
            };

            $scope.searchLanesAfterMidnight = () => {
                $location.url();
            };

            const getWeekdayDate = (weekday) => {
                const dayINeed = weekday; // for Thursday
                const today = moment().isoWeekday();

                // if we haven't yet passed the day of the week that I need:
                if (today <= dayINeed) {
                    // then just give me this week's instance of that day
                    return moment().isoWeekday(dayINeed).format("DD-MM-YYYY");
                } else {
                    // otherwise, give me *next week's* instance of that same day
                    return moment()
                        .add(1, "weeks")
                        .isoWeekday(dayINeed)
                        .format("DD-MM-YYYY");
                }

                // console.log(dayOfWeek);
            };

            const replaceSearchDate = (path, date) => {
                return path.replace(replacer, date);
            };
        },
    };
}
